import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const Hero = () => {
  return (
    <section className="relative w-full h-[88vh] min-h-[640px] overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Boat 2 Tee — Coastal lifestyle apparel"
          className="w-full h-full object-cover animate-slow-zoom"
          style={{ objectPosition: "center 8%" }}
        />
        {/* Gradient that darkens bottom for tagline readability, leaves top-left brand text visible */}
        <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-navy/20 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 h-full flex items-end pb-20 md:pb-28">
        <div className="max-w-2xl text-white">
          <h1
            className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight mb-6 animate-fade-in-up"
            style={{ animationDelay: "0.2s", opacity: 0 }}
            data-testid="hero-headline"
          >
            Tee Off.<br />
            <span className="italic font-light text-seafoam-400">Tide</span> Out.
          </h1>
          <p
            className="text-base sm:text-lg text-white/85 leading-relaxed max-w-lg mb-10 animate-fade-in-up"
            style={{ animationDelay: "0.4s", opacity: 0 }}
          >
            Coastal apparel built for the people who chase tides and tee times. Performance fabrics, tailored fits, embroidered details.
          </p>

          <div
            className="flex flex-col sm:flex-row gap-3 animate-fade-in-up"
            style={{ animationDelay: "0.6s", opacity: 0 }}
          >
            <Link
              to="/shop"
              data-testid="hero-cta-shop"
              className="group inline-flex items-center justify-center gap-2 bg-white text-navy px-8 py-4 text-sm font-bold uppercase tracking-[0.18em] hover:bg-seafoam hover:text-navy transition-all duration-300"
            >
              Shop the Collection
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={2} />
            </Link>
            <Link
              to="/collections/premium-hoodies"
              data-testid="hero-cta-premium"
              className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-8 py-4 text-sm font-bold uppercase tracking-[0.18em] hover:bg-white hover:text-navy transition-all duration-300"
            >
              Premium Hoodies
            </Link>
          </div>
        </div>
      </div>

      {/* Tagline ticker */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-navy/90 backdrop-blur-sm border-t border-white/10 py-3 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap text-white/80 text-xs uppercase tracking-[0.3em]">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-12 px-6">
              <span>Tee Off. Tide Out.</span>
              <span className="text-seafoam">◆</span>
              <span>High Tide. Low Score.</span>
              <span className="text-seafoam">◆</span>
              <span>Life on the Water and the Course</span>
              <span className="text-seafoam">◆</span>
              <span>UPF 50+ Performance Fabrics</span>
              <span className="text-seafoam">◆</span>
              <span>Free Shipping Over $75</span>
              <span className="text-seafoam">◆</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
